
import React, { useMemo } from 'react'
import { type NodeProps } from '@xyflow/react'
import { CommentNode } from '@/components/canvas/nodes/variants/CommentNode'
import type { GenieNodeState } from '@genieartinc/schemas'
import { useNodeStateChange } from '@/components/canvas/hooks/useNodeStateChange'

export interface CommentNodeNodeData extends Record<string, unknown> {
  state: GenieNodeState
  onHoverChange?: (hovered: boolean) => void
}

function CommentNodeNodeComponent({ id, data, selected }: NodeProps) {
  const nodeData = data as unknown as CommentNodeNodeData
  const { state: genieState, onHoverChange } = nodeData
  const onStateChange = useNodeStateChange(id)

  const commentProps = useMemo(
    () => {
      const safeState = (genieState || {}) as unknown as Record<string, unknown>
      return {
        id,
        selected,
        onHoverChange,
        onStateChange,
        state: safeState,
      }
    },
    [id, genieState, selected, onHoverChange, onStateChange],
  )

  return <CommentNode {...commentProps} />
}

export const CommentNodeNode = React.memo(
  CommentNodeNodeComponent,
  (prevProps, nextProps) => {
    const prevData = prevProps.data as unknown as CommentNodeNodeData
    const nextData = nextProps.data as unknown as CommentNodeNodeData
    return (
      prevData.state?.comment === nextData.state?.comment &&
      prevData.state?.resolved === nextData.state?.resolved &&
      prevProps.selected === nextProps.selected &&
      prevProps.id === nextProps.id
    )
  },
)

CommentNodeNode.displayName = 'CommentNodeNode'
